import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import JWTLoginTab from 'app/main/sign-in/tabs/JWTLoginTab';
import JWTLoginVerification from 'app/main/sign-in/tabs/JWTLoginVerification';
import { getCustomerBasedProfile } from '../apps/common/AuraFunctions';
import AppVersion from 'app/shared-components/AppVersion';

function SignInPage(props) {
  return (
    <div className="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-1 min-w-0">
      <Paper className="h-full sm:h-auto md:flex md:items-center md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-16 sm:p-48 md:p-64 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none ltr:border-r-1 rtl:border-l-1">
        <div className="w-full max-w-320 sm:w-320 mx-auto sm:mx-0">
          <div className="flex items-center m-24 mb-48">
            <img src={getCustomerBasedProfile.companyLogo} alt="logo" />
          </div>

          <Typography className="mt-32 text-4xl font-extrabold tracking-tight leading-tight">
            Sign in
          </Typography>
          <div className="mt-32">
            {props.pageType === 'login' && <JWTLoginTab />}
            {props.pageType === 'verify' && <JWTLoginVerification />}
          </div>
          {/* PGSS-5442: on the sign-in screen too, so the build can be identified before anyone
              signs in -- which is exactly when a login problem gets reported. */}
          <div className="mt-24 flex justify-center">
            <AppVersion />
          </div>
        </div>
      </Paper>

      <Box
        className="relative hidden md:flex flex-auto items-center justify-center h-full p-64 lg:px-112 overflow-hidden"
        sx={{ backgroundColor: 'primary.main' }}
      >
        <svg
          className="absolute inset-0 pointer-events-none"
          viewBox="0 0 960 540"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMax slice"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Box
            component="g"
            sx={{ color: 'primary.light' }}
            className="opacity-20"
            fill="none"
            stroke="currentColor"
            strokeWidth="100"
          >
            <circle r="234" cx="196" cy="23" />
            <circle r="234" cx="790" cy="491" />
          </Box>
        </svg>
        <Box
          component="svg"
          className="absolute -top-64 -right-64 opacity-20"
          sx={{ color: 'primary.light' }}
          viewBox="0 0 220 192"
          width="220px"
          height="192px"
          fill="none"
        >
          <defs>
            <pattern
              id="837c3e70-6c3a-44e6-8854-cc48c737b659"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect x="0" y="0" width="4" height="4" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)" />
        </Box>

        <div className="z-10 relative w-full max-w-2xl">
          <div className="text-7xl font-bold leading-none text-gray-100">
            <div>Welcome!</div>
          </div>
          <div className="mt-24 text-lg tracking-tight leading-6 text-gray-400">
            {getCustomerBasedProfile.welcomeText}
          </div>
        </div>
      </Box>
    </div>
  );
}

export default SignInPage;
